import { Outlet, useMatches } from "react-router";
import { ErrorBox, ReconnectingOverlay } from "./dialogs";
import { matchedHandle, navbarText } from "./handles";
import { Navbar } from "./Navbar";
import { SeatedBanner } from "./SeatedBanner";

/**
 * _Layout: the navbar, the "seated at table N" banner (10d), then <main> with the error box and the page, and the
 * reconnecting overlay. The page's top element is a child of main.row, as Bootstrap's `.row > *` rules expect. The
 * shell's root element around all of it is `display: contents`, so these are laid out as the body's own children, as
 * in _Layout.
 */
export function AppLayout() {
    const handle = matchedHandle(useMatches());

    return (
        <>
            <Navbar text={navbarText(handle)} />
            <SeatedBanner />
            <main className="row bg-light justify-content-start m-0 p-0 h-100" style={{ zIndex: 0 }}>
                <ErrorBox />
                <Outlet />
            </main>
            <ReconnectingOverlay />
        </>
    );
}
